// The docs tree query is rooted in groups, so an article that belongs to no
// group (the v2 API detaches one with `group_id: null`) never appears in it.
// A proposal can still target that article, so the review view falls back to a
// direct by-id fetch instead of dropping the user on the docs home.
export function pickReviewArticle<T extends { id: string }>(
	treeArticle: T | undefined,
	detachedArticle: T | undefined,
	reviewArticleId: string | undefined,
): T | undefined {
	if (!reviewArticleId) return treeArticle
	if (treeArticle?.id === reviewArticleId) return treeArticle
	return detachedArticle?.id === reviewArticleId ? detachedArticle : undefined
}
